export function openAboutModal(): void {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal-panel" role="dialog" aria-modal="true">
      <button class="modal-close" aria-label="Close">×</button>
      <h2>About ConflictMap</h2>
      <p>
        ConflictMap tracks every known armed conflict in the world — from major wars killing tens of thousands
        per year to simmering border skirmishes that rarely make the news. Most conflict maps show only the
        headline wars. This one surfaces everything.
      </p>

      <h3>What counts as a "conflict"?</h3>
      <p>
        We use the Uppsala Conflict Data Program (UCDP) definition: organised violence between two parties
        where at least 25 battle-related deaths have been recorded in a calendar year. This includes
        state-based conflicts (government vs rebel/government), non-state conflicts (rebel vs rebel,
        gang vs gang), and one-sided violence against civilians.
      </p>

      <h3>Data sources</h3>
      <p>
        Conflict data is curated from multiple authoritative sources:
      </p>
      <p>
        <strong>UCDP</strong> — Uppsala Conflict Data Program (Uppsala University, Sweden). The world's
        leading academic dataset on organised violence, tracking conflicts since 1946.
        <br/>
        <strong>ACLED</strong> — Armed Conflict Location & Event Data Project. Real-time event-level
        data on political violence and protest.
        <br/>
        <strong>International Crisis Group</strong> — Independent analysis of deadly conflicts and
        how to prevent or resolve them.
      </p>

      <h3>How categories work</h3>
      <p>
        Conflicts are classified by annual fatality count:
        <br/><strong style="color: #dc2626">Major War</strong> — 10,000+ fatalities/year
        <br/><strong style="color: #ea580c">Minor War</strong> — 1,000–9,999 fatalities/year
        <br/><strong style="color: #d97706">Conflict</strong> — 100–999 fatalities/year
        <br/><strong style="color: #65a30d">Skirmish</strong> — under 100 fatalities/year
      </p>

      <h3>Update frequency</h3>
      <p>
        The curated dataset is reviewed and updated periodically based on UCDP annual releases,
        ACLED weekly updates, and Crisis Group reporting. Fatality figures are best estimates
        and should be treated as approximate.
      </p>

      <h3>Limitations</h3>
      <p>
        Fatality counts are inherently uncertain — different sources give different numbers.
        We use conservative best estimates. "Deaths" refers to battle-related fatalities
        (direct violence), not indirect deaths from famine, disease, or displacement caused
        by conflict, which are often many times higher.
      </p>
    </div>
  `;

  document.body.appendChild(overlay);
  document.body.classList.add('modal-open');

  const close = () => {
    overlay.remove();
    document.body.classList.remove('modal-open');
  };

  overlay.querySelector('.modal-close')!.addEventListener('click', close);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });

  const onKey = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      close();
      document.removeEventListener('keydown', onKey);
    }
  };
  document.addEventListener('keydown', onKey);
}
